import React, { useState, useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";
import fatima from "../../../Images/fatima.png";
import grace from "../../../Images/grace.png";
import profile3 from "../../../Images/image3.png";
import profile4 from "../../../Images/image4.png";
import rachel from "../../../Images/rachel.png";
import sofia from "../../../Images/sofia.png";

const testimonials = [
  {
    id: 1,
    name: "Priya Desai",
    position: "HR Director",
    image: profile4,
    quote:
      "We used SelfSync to evaluate 60 employees across departments. The insights were eye-opening — we realigned roles and saw a 22% jump in team efficiency in just 8 weeks. Every HR team needs this!",
  },
  {
    id: 2,
    name: "Grace Liu",
    position: "Start-up Founder",
    image: grace,
    quote:
      "SelfSync helped us uncover misalignment we never saw before. After reassessing our team, we made strategic shifts that directly impacted growth. This tool is a must for every startup founder.",
  },
  {
    id: 3,
    name: "Sofia Ramirez",
    position: "Business Coach",
    image: sofia,
    quote:
      "As a business coach, I recommend SelfSync to all my clients. It’s the simplest way to understand your team’s true potential and align roles smartly. Brilliant tool!",
  },
  {
    id: 4,
    name: "Michael Thompson",
    position: "Recruitment Agency",
    image: profile3,
    quote:
      "SelfSync has changed how we screen candidates. Instead of relying on instinct, we now have data-backed insights. Our clients are happier, and our placements stick longer. It's a true competitive edge.",
  },
  {
    id: 5,
    name: "Fatima Rahmani",
    position: "Senior HR Manager",
    image: fatima,
    quote:
      "We tested SelfSync on our sales team. Within weeks, we saw reduced attrition and higher productivity. It’s a low-cost, high-impact tool every HR leader should try.",
  },
  {
    id: 6,
    name: "Rachel Lim",
    position: "Angel Investor",
    image: rachel,
    quote:
      "SelfSync is now a non-negotiable in my due diligence process. It helps me understand not just the founder, but the full team’s alignment and readiness to scale.",
  },
];

// Duplicate the testimonials list to make the scroll seamless
const duplicatedTestimonials = [...testimonials, ...testimonials];

export default function Testimonials() {
  const controls = useAnimation();
  const [duration, setDuration] = useState(90);

  // Ref to track if hovered
  const isHovered = useRef(false);

  useEffect(() => {
    function updateDuration() {
      if (window.innerWidth < 768) {
        setDuration(150);
      } else {
        setDuration(90);
      }
    }
    updateDuration();

    window.addEventListener("resize", updateDuration);
    return () => window.removeEventListener("resize", updateDuration);
  }, []);

  useEffect(() => {
    if (!isHovered.current) {
      // Start or resume animation when not hovered
      controls.start({
        x: "-50%",
        transition: {
          ease: "linear",
          duration: duration,
          repeat: Infinity,
        },
      });
    } else {
      // When hovered, stop animation (pauses in place)
      controls.stop();
    }
  }, [duration, controls]);

  function handleMouseEnter() {
    isHovered.current = true;
    controls.stop();
  }

  function handleMouseLeave() {
    isHovered.current = false;
    controls.start({
      x: "-50%",
      transition: {
        ease: "linear",
        duration: duration,
        repeat: Infinity,
      },
    });
  }

  return (
    <div
      className="bg-gray-50 py-20 max-md:py-10 overflow-hidden relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleMouseEnter}
      onTouchEnd={handleMouseLeave}
    >
      <div className="max-w-7xl mx-auto text-center mb-10 px-4">
        <h2 className="text-4xl font-bold bg-gradient-to-r from-[#6C2BD9] via-[#33C3F0] to-[#40E0D0] bg-clip-text text-transparent">
          Testimonials
        </h2>
      </div>

      <div className="relative w-full overflow-x-auto scrollbar-hide">
        <motion.div
          className="flex gap-6 md:gap-8 w-max"
          animate={controls}
          initial={{ x: 0 }}
        >
          {duplicatedTestimonials.map((t, index) => (
            <div
              key={index}
              className="
                flex-shrink-0
                bg-white shadow rounded-xl p-6
                min-w-[280px] max-w-[280px]
                sm:min-w-[350px] sm:max-w-[350px]
                md:min-w-[500px] md:max-w-[500px]
              "
            >
              <div className="flex flex-col items-center text-center cursor-pointer">
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden border-4 border-[#e1d3c5] mb-4">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <blockquote className="text-gray-700 mb-3 relative text-sm sm:text-base">
                  <img
                    src="https://www.clker.com/cliparts/f/x/1/G/a/P/double-quote-hi.png"
                    alt="quote"
                    className="absolute -top-4 left-[-15px] w-5 h-5 opacity-60"
                  />
                  <p className="z-10 relative">{t.quote}</p>
                  <img
                    src="https://www.clker.com/cliparts/f/x/1/G/a/P/double-quote-hi.png"
                    alt="quote"
                    className="absolute -bottom-3 right-[-15px] w-5 h-5 opacity-60 transform rotate-180"
                  />
                </blockquote>
                <div>
                  <h4 className="font-semibold text-gray-900 text-base sm:text-lg">{t.name}</h4>
                  <p className="text-gray-600 text-sm sm:text-base">{t.position}</p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}